/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EContentHidingMode } from './EContentHidingMode';
import {
    EContentHidingModeFromJSON,
    EContentHidingModeFromJSONTyped,
    EContentHidingModeToJSON,
} from './EContentHidingMode';
import type { SuiviApprenantActionEditDto } from './SuiviApprenantActionEditDto';
import {
    SuiviApprenantActionEditDtoFromJSON,
    SuiviApprenantActionEditDtoFromJSONTyped,
    SuiviApprenantActionEditDtoToJSON,
} from './SuiviApprenantActionEditDto';
import type { SuiviApprenantFichierGridDto } from './SuiviApprenantFichierGridDto';
import {
    SuiviApprenantFichierGridDtoFromJSON,
    SuiviApprenantFichierGridDtoFromJSONTyped,
    SuiviApprenantFichierGridDtoToJSON,
} from './SuiviApprenantFichierGridDto';

/**
 * 
 * @export
 * @interface FcbSuiviApprenantDetailsDto
 */
export interface FcbSuiviApprenantDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    encodeur?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    action?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    fromSmile?: boolean;
    /**
     * 
     * @type {SuiviApprenantActionEditDto}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    suiviAction?: SuiviApprenantActionEditDto;
    /**
     * 
     * @type {Array<SuiviApprenantFichierGridDto>}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    fichiers?: Array<SuiviApprenantFichierGridDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idsuivi?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idclasse?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    dateSuivi?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    contenu?: string | null;
    /**
     * 
     * @type {EContentHidingMode}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    contentHidingMode?: EContentHidingMode;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    creationUser?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idlieuRencontre?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idcentre?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idrealisateurSuivi?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idformateur?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idmode?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idmetier?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idsousTypeSuivi?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    idtypeSuivi?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbSuiviApprenantDetailsDto
     */
    autreSousType?: string | null;
}

/**
 * Check if a given object implements the FcbSuiviApprenantDetailsDto interface.
 */
export function instanceOfFcbSuiviApprenantDetailsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSuiviApprenantDetailsDtoFromJSON(json: any): FcbSuiviApprenantDetailsDto {
    return FcbSuiviApprenantDetailsDtoFromJSONTyped(json, false);
}

export function FcbSuiviApprenantDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSuiviApprenantDetailsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'encodeur': !exists(json, 'encodeur') ? undefined : json['encodeur'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'fromSmile': !exists(json, 'fromSmile') ? undefined : json['fromSmile'],
        'suiviAction': !exists(json, 'suiviAction') ? undefined : SuiviApprenantActionEditDtoFromJSON(json['suiviAction']),
        'fichiers': !exists(json, 'fichiers') ? undefined : (json['fichiers'] === null ? null : (json['fichiers'] as Array<any>).map(SuiviApprenantFichierGridDtoFromJSON)),
        'idsuivi': !exists(json, 'idsuivi') ? undefined : json['idsuivi'],
        'idclasse': !exists(json, 'idclasse') ? undefined : json['idclasse'],
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'dateSuivi': !exists(json, 'dateSuivi') ? undefined : (json['dateSuivi'] === null ? null : new Date(json['dateSuivi'])),
        'contenu': !exists(json, 'contenu') ? undefined : json['contenu'],
        'contentHidingMode': !exists(json, 'contentHidingMode') ? undefined : EContentHidingModeFromJSON(json['contentHidingMode']),
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (json['creationDate'] === null ? null : new Date(json['creationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'idlieuRencontre': !exists(json, 'idlieuRencontre') ? undefined : json['idlieuRencontre'],
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'idrealisateurSuivi': !exists(json, 'idrealisateurSuivi') ? undefined : json['idrealisateurSuivi'],
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'idmode': !exists(json, 'idmode') ? undefined : json['idmode'],
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'idsousTypeSuivi': !exists(json, 'idsousTypeSuivi') ? undefined : json['idsousTypeSuivi'],
        'idtypeSuivi': !exists(json, 'idtypeSuivi') ? undefined : json['idtypeSuivi'],
        'autreSousType': !exists(json, 'autreSousType') ? undefined : json['autreSousType'],
    };
}

export function FcbSuiviApprenantDetailsDtoToJSON(value?: FcbSuiviApprenantDetailsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'encodeur': value.encodeur,
        'action': value.action,
        'fromSmile': value.fromSmile,
        'suiviAction': SuiviApprenantActionEditDtoToJSON(value.suiviAction),
        'fichiers': value.fichiers === undefined ? undefined : (value.fichiers === null ? null : (value.fichiers as Array<any>).map(SuiviApprenantFichierGridDtoToJSON)),
        'idsuivi': value.idsuivi,
        'idclasse': value.idclasse,
        'idapprenant': value.idapprenant,
        'dateSuivi': value.dateSuivi === undefined ? undefined : (value.dateSuivi === null ? null : value.dateSuivi.toISOString()),
        'contenu': value.contenu,
        'contentHidingMode': EContentHidingModeToJSON(value.contentHidingMode),
        'creationUser': value.creationUser,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate === null ? null : value.creationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'idlieuRencontre': value.idlieuRencontre,
        'idcentre': value.idcentre,
        'idrealisateurSuivi': value.idrealisateurSuivi,
        'idformateur': value.idformateur,
        'idmode': value.idmode,
        'idmetier': value.idmetier,
        'idsousTypeSuivi': value.idsousTypeSuivi,
        'idtypeSuivi': value.idtypeSuivi,
        'autreSousType': value.autreSousType,
    };
}

